var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.skinClasses],staticStyle:{"height":"100vh","overflow-y":"auto"},attrs:{"id":"app"},on:{"scroll":_vm.handleScroll}},[_c(_vm.layout,{tag:"component"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }